/* eslint-disable import/prefer-default-export */
export const shuffleArray = (array) => {
  const newArray = array.slice()
  for (let i = newArray.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]]
  }
  return newArray
}
